export const ariaTenantToken =
    'db334b301e7b474db5e0f02f07c51a47-a1b5bc36-1bbe-482f-a64a-c2d9cb606706-7439';
export const nexusTenantToken = 1755;
